// File to interact with google forms
// getQuestions will return a list of question dictionaries
//              [{Question: "What's the question...?",
//               Type: "Long Answer", ("Multiple Choice", "Choose All", "Short Answer") ,
//               Choices: ["Choice 1", "Choice 2"]},
//               ...]
// answerQuestions will take a list of questionAnswerDictionaries: questions:answers and fill out the form
//              [{Question: "Answer"},
//              ...]
//

var questionInteractions = {};

function getSelector(elm) {
  // This function will return the selector for a given element
  if (elm.tagName === 'BODY') return 'BODY';
  const names = [];
  while (elm.parentElement && elm.tagName !== 'BODY') {
    if (elm.id) {
      names.unshift('#' + elm.getAttribute('id')); // getAttribute, because `elm.id` could also return a child element with name "id"
      break; // Because ID should be unique, no more is needed. Remove the break, if you always want a full path.
    } else {
      let c = 1,
        e = elm;
      for (; e.previousElementSibling; e = e.previousElementSibling, c++);
      names.unshift(elm.tagName + ':nth-child(' + c + ')');
    }
    elm = elm.parentElement;
  }
  return names.join('>');
}

function sleep(ms) {
  return new Promise((resolve) => setTimeout(resolve, ms));
}

export function gFormsGetQuestions() {
  /*
    Description: The function for scraping the page to get the questions
    Args: None
    Return: A list of questions
        [
            {
                Question: "What's the question...?", 
                Type: "Short Answer", ("Multiple Choice", "Choose All", "Long Answer") 
                Choices: ["Choice 1", "Choice 2"]
            },
            ...
        }

    */

  var qReturn = [];

  // Get all the questions on the page
  const questions = document.querySelectorAll('div[role="listitem"]');

  var qIndex = -1;
  questions.forEach((question) => {
    qIndex++;
    // For each of the questions we need to figure out the question type, text, and potentially choices

    // console.log("Working on question: " + question.innerText);
    var questionText = question.innerText;
    questionText = questionText
      .replace('\nYour answer', '')
      .replace('\nClear selection', '');
    questionText = questionText.replace(/\s+$/gm, '');
    // console.log("Question Text: " + questionText);

    var qType = 'Short Answer';
    var qChoices = [];

    var qInteraction = { Choices: {} };

    /********* Get the Choices if not short answer *********/
    // check if question is a radio button or a dropdown
    // if it is, then it is a multiple choice question
    // if it is not, then it is a short answer question
    // if it is a multiple choice question, get the choices
    // if it is a short answer question, do nothing
    var choices = question.querySelectorAll('div[role="radio"]');
    // Multiple Choice
    if (choices.length > 0) {
      // console.log("Got a multiple choice");
      qType = 'Multiple Choice';

      // Get the list of choices
      choices.forEach((choice) => {
        var choiceText = choice.getAttribute('data-value');
        qChoices.push(choiceText);
        questionText = questionText.replace('\n' + choiceText, '');
        qInteraction['Choices'][choiceText] = getSelector(choice);

        // Play with the clickable part now
        // choice.click();
      });
    }

    // Drop Down
    var gotDrop = question.querySelector('div[role="listbox"]');
    if (gotDrop != null) {
      // console.log("Got a dropdown");
      qType = 'Multiple Choice';
      // Get a list of choices and remove them from the question text
      var choices = question.querySelectorAll('div[role="option"]');
      choices.forEach((choice) => {
        if (choice.innerText != 'Choose') {
          qChoices.push(choice.innerText);
        }
        // remove the choices from the question text
        questionText = questionText.replace('\n' + choice.innerText, '');

        // Try to interact with the dropdown TODO, not that easy unfortunately
        var lBox = question.querySelector('div[role="listbox"]');
        // get all children for the lBox
        // 0 will open the dropdown
        // 1.children holds the list of options
        var iterator = lBox.children;
        var dropDown = iterator[0];
        qInteraction['Dropdown'] = getSelector(dropDown);
        qInteraction['Choices'][choice.innerText] = true;
        qInteraction['ChoicesDrop'] = getSelector(iterator[1]);
        // console.log(qInteraction['Choices'])
        // dropDown.click();

        // choices = iterator[1].children
        // qInteraction['Choices'] = {};
        // // iterator[1].children[0] // The Choose Option
        // // iterator[1].children[1] // The Divider
        // console.log("Hi")
        // console.log(choices.length)
        // for (var i = 2; i < choices.length; i++)
        // {
        //     console.log(choices[i].innerText);
        //     qInteraction['Choices'][choices[i].innerText] = getSelector(choices[i]);
        // }

        // console.log(choices);
        // sleep(500).then(() => {
        //     choices[3].click() // The first choice
        // });
      });

      // console.log("Choices are: ");
      // console.log(qChoices)
    }

    // Check if this is a date question
    // <input type="date" class="whsOnd zHQkBf" jsname="YPqjbf" autocomplete="off" tabindex="0" aria-labelledby="i54" aria-disabled="false" max="2073-01-01" data-initial-value="">
    var gotDate = question.querySelector('input[type="date"]');
    if (gotDate != null) {
      // console.log("Got a date question");
      qType = 'Date';
      questionText = questionText.replace(/\nDate$/, '');

      // Handle the interaction
      var found = question.querySelector('input');
      if (found != null) {
        // Works but need to clear the input first
        qInteraction['Input'] = getSelector(found);
      }
    }

    // Check if it is a choose all question/choice
    var choices = question.querySelectorAll('div[role="checkbox"]');
    if (choices.length > 0) {
      // Check if this is a child of the real question that has already been parsed
      if (choices.length == 1) {
        // console.log("This is a child of the real question that has already been parsed")
        // loop over all the previous questions and see if any of them are the parent
        for (var i = qIndex - 1; i >= 0; i--) {
          if (questions[i].contains(choices[0])) {
            // console.log("Found the parent question")
            return;
          }
        }

        // continue in the for loop if we found the parent
      }
      // console.log("Got a choose all question");
      qType = 'Choose All';
      // Get the list of choices
      choices.forEach((choice) => {
        var choiceText = choice.parentElement.textContent;
        qChoices.push(choiceText);
        questionText = questionText.replace('\n' + choiceText, '');
        qInteraction['Choices'][choiceText] = getSelector(choice);
      });
    }

    // if question is short answer store the text box where we will drop the response text
    if (qType == 'Short Answer') {
      // Short answer
      var found = question.querySelector('input');
      if (found != null) {
        // Works but need to clear the input first
        qInteraction['Input'] = getSelector(found);
      }
      // Long answer
      else {
        found = question.querySelector('textarea');
        if (found != null) {
          qInteraction['Input'] = getSelector(found);
        } else {
          qInteraction['Input'] = null;
          console.log(question);
          console.error('Failed to find the input for the short answer question');
        }
      }

      // console.log("Got a short answer");
      // if (qInteraction['Input'] != null)
      // {
      //     qInteraction['Input'].value = "Hi Jake"
      // }
      // Note, there is some JS we need to do to hide the "Your answer" text
    }

    // # TODO Checkbox (Choose multiple) and other question types

    // console.log({
    //     "Question": questionText,
    //     "Type": qType,
    //     "Format": format,
    //     "Choices": qChoices,
    // })
    qReturn.push({
      Question: questionText,
      Type: qType,
      Choices: qChoices
    });

    // We need to hold on to the intractable part of the question
    // TODO, handle this when we are calling from the chrome extension plugin things...
    qInteraction['Type'] = qType;
    questionInteractions[questionText] = qInteraction;
  });

  console.log('Questions are:');
  console.log(qReturn);

  // return {"Q": qReturn,  "I": questionInteractions};

  return qReturn;
}

export function gFormsAnswerQuestions(answers) {
  /*
    Description: Fill out the form using the provided answers
    Args: List of Answers in a dictionary, [{Question:"This is what the question is", 
                                             Answer:"The Answer"}, ...]
    Return: A list of any questions that were not answered, perhaps the answer didn't match the questions expected or whatnot...
        [
            {
                Question: "Where was the injury?", 
                Answer: "Back" 
                Error: "The error message" (Choice not found, etc)
            },
            ...
        }

    */
  //    TODO
  console.log(answers);
  console.log(answers.length);
  var results = [];
  for (var i = 0; i < answers.length; i++) {
    console.log(
      'Answering Question: ' +
        answers[i]['Question'] +
        ' with: ' +
        answers[i]['Answer']
    );
    var question = answers['Question'];
    var answer = answers['Answer'];
    var success = gFormsAnswerQuestion(question, answer);
    if (!success) {
      console.error(
        'Failed to answer question: ' + question + ' with: ' + answer
      );
      results[question] =
        'Failed to answer question: ' + question + ' with: ' + answer;
    } else {
      console.log(
        'Successfully answered question: ' + question + ' with: ' + answer
      );
      results[question] =
        'Successfully answered question: ' + question + ' with: ' + answer;
    }
  }
  return results;
}

function getGFormsDate(date) {
  // Answer must be in the form of YYYY-MM-DD take the ISO time and convert it to this format
  var d = new Date(date);
  var month = '' + (d.getMonth() + 1);
  var day = '' + d.getDate();
  var year = d.getFullYear();
  if (month.length < 2) {
    month = '0' + month;
  }
  if (day.length < 2) {
    day = '0' + day;
  }
  return [year, month, day].join('-');
}

// A function to fill out the form with the data from the API
export function gFormsAnswerQuestion(question, answer) {
  // console.log("In the fillForm function");
  // console.log("Question is: " + question);
  // console.log("Answer is: " + answer);
  // console.log(questionInteractions);

  // Check if question in the questionInteractions object
  if (questionInteractions[question] == null) {
    console.error(
      'Question not found in the questionInteractions object',
      question
    );
    // log all the questions in the questionInteractions object
    console.log('Questions in the questionInteractions object are: ');
    console.log(Object.keys(questionInteractions));

    // TODO handle the question not being an exact match
    return false;
  }

  // Get the question interaction
  var qInteraction = questionInteractions[question];
  // console.log("Logging the qInteraction Object")
  // console.log(qInteraction)

  if (qInteraction['Type'] == 'Short Answer') {
    // console.log("Short answer question");
    // console.log(qInteraction['Input']);
    if (qInteraction['Input'] != null) {
      // console.log("Found the input for the short answer question, setting the value")
      var txtBox = document.querySelector(qInteraction['Input']);
      txtBox.value = answer;
      // if its a short answer do this
      if (txtBox.parentElement.childNodes[1] != null) {
        txtBox.parentElement.childNodes[1].style.visibility = 'hidden'; // Clear the default text
      } else {
        // Long Answer
        txtBox.parentElement.parentElement.childNodes[0].style.visibility =
          'hidden'; // Clear the default text
      }
      // txtBox.parentElement.childNodes[1].style.visibility = "hidden"  // Clear the default text

      return true;
    } else {
      console.error('Failed to find the input for the short answer question');
      return false;
    }
  } else if (qInteraction['Type'] == 'Multiple Choice') {
    var dropdown = qInteraction['Dropdown'];
    if (dropdown != null) {
      // Check if answer is in the choices dict keys

      if (qInteraction['Choices'][answer] == null) {
        console.error('Answer not found in the choices list - ', answer);
        console.log('Choices are: ');
        console.log(qInteraction['Choices']);
        return false;
      }
      // console.log("Found the dropdown for the multiple choice question, setting the value")
      var dropDown = document.querySelector(dropdown);
      dropDown.click(); // Open the dropdown
      sleep(500).then(() => {
        // console.log("Clicking the choice for the multiple choice question")
        // loop over the choices and click the one that matches the answer
        var choices = document.querySelector(qInteraction['ChoicesDrop']);
        choices = choices.children;

        for (var i = 2; i < choices.length; i++) {
          // console.log(choices[i].innerText);
          if (choices[i].innerText == answer) {
            choices[i].click();
            return true;
          }
        }
        console.error(
          'Failed to find the choice for the multiple choice question',
          answer
        );
        console.log('Choices are: ');
        console.log(Object.keys(qInteraction['Choices']));
        console.log(qInteraction);
        return false;
      });
      return true;
    } else {
      if (qInteraction['Choices'][answer] != null) {
        var choice = document.querySelector(qInteraction['Choices'][answer]);
        // Check if already clicked
        if (choice.getAttribute('aria-checked') == 'false') {
          choice.click();
        }
        return true;
      } else {
        console.error(
          'Failed to find the choice for the multiple choice question',
          answer
        );
        console.log('Choices are: ');
        console.log(Object.keys(qInteraction['Choices']));
        console.log(qInteraction);
        return false;
      }
    }
  } else if (qInteraction['Type'] == 'Date') {
    var input = qInteraction['Input'];
    if (input != null) {
      // console.log("Found the input for the date question, setting the value")
      var dateInput = document.querySelector(input);
      var gFormDate = getGFormsDate(answer);
      if (gFormDate == null) {
        console.error('Failed to convert the date to the gForm format');
        return false;
      }
      dateInput.value = getGFormsDate(answer);
      return true;
    } else {
      console.error('Failed to find the input for the date question');
      return false;
    }
  } else if (qInteraction['Type'] == 'Choose All') {
    // console.log("Choose All question");
    // console.log(qInteraction['Input']);
    for (var i = 0; i < answer.length; i++) {
      if (qInteraction['Choices'][answer[i]] != null) {
        var choice = document.querySelector(qInteraction['Choices'][answer[i]]);
        // Check if already clicked
        if (choice.getAttribute('aria-checked') == 'false') {
          choice.click();
        }
      } else {
        console.error(
          'Failed to find the choice for the choose all question',
          answer[i]
        );
        console.log('Choices are: ');
        console.log(Object.keys(qInteraction['Choices']));
        console.log(qInteraction);
        return false;
      }
    }
  } else {
    console.error('Question type not recognized: ' + qInteraction['Type']);
    return false;
  }
  return false;
}

export async function getLogFromInjector() {
  try {
    const htmlContent = document.documentElement.outerHTML;
    chrome.runtime.sendMessage({ type: 'INJECTOR_ERROR', error:  { htmlContent: htmlContent} });
    return { htmlContent: htmlContent};
  } catch (error) {
    // Return the full HTML content of the document
    console.error('Error occurred while fetching document:', error);
    getLogFromInjector()    
  }
}